import EventBus from '@/EventBus';
import DefaultImageProps from '@/components/DesignObjects/ImageObject';
import DefaultVideoProps from '@/components/DesignObjects/VideoObject';
import {
  uuid,
} from 'vue-uuid';
import {
  getMaxZIndex,
} from '@/components/Helper';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';

export default {
  methods: {
    calculateVideoDimensions({ width, height }) {
      const canvasAspectRatio = this.width / this.height;
      const videoAspectRatio  = width / height;

      let limitingFactor,
        newVideoWidth,
        newVideoHeight;

      if (canvasAspectRatio > videoAspectRatio) {
        limitingFactor = 'width';
      } else {
        limitingFactor = 'height';
      }

      if (limitingFactor === 'width') {
        newVideoWidth  = this.width;
        newVideoHeight = this.width / videoAspectRatio;
      } else {
        newVideoWidth  = this.height * videoAspectRatio;
        newVideoHeight = this.height;
      }

      if (newVideoWidth > this.width) {
        newVideoWidth  = this.width;
        newVideoHeight = this.width / videoAspectRatio;
      }

      if (newVideoHeight > this.height) {
        newVideoWidth  = this.height * videoAspectRatio;
        newVideoHeight = this.height;
      }

      return { newVideoWidth: parseInt(newVideoWidth), newVideoHeight: parseInt(newVideoHeight) };
    },
    removeObjectFromCanvas() {
      console.log('Deleting object');
      const index = parseInt(this.targets[0].dataset.elementindex);
      // EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.CLEARED);
      EventBus.$emit(ApplicationEventTypes.ModalEvents.TOGGLE_CONFIRMATION_MODAL, {
        request: 'DeleteReq',
        data:    index,
        message: 'Are you sure you want to delete this?',
        isVideo: true,
      });
    },

    AddNewObjectVideo(newVideData) {
      const productWidth  = this.width;
      const productHeight = this.height;
      const {
        data,
      } = new DefaultVideoProps();

      const temp                         = Math.min(this.width, this.height);
      data.Name                          = 'Video';
      data.Id                            = uuid.v1();
      data.elementIndex                  = 0;
      data.isSelected                    = false;
      data.RotateDegree                  = 0;
      data.AlternativeVideoUrlsResVersion = newVideData.AlternativeVideoUrlsResVersion;
      data.PageNo                        = this.activePage;
      data.isImageAddedOnCanvasFromModel = true;
      const heightRatio                  = newVideData.videoDetails.height / newVideData.videoDetails.width;
      data.Width                         = productWidth / 1.5;
      data.Height                        = Math.round(data.Width * heightRatio);
      data.X                             = Math.round(Math.abs((productWidth / 2) - data.Width / 2));
      data.Y                             = Math.round(Math.abs((productHeight / 2) - data.Height / 2));
      data.videoDetails.VideoSourceUrl   = newVideData.videoDetails.VideoSourceUrl;
      data.videoDetails.mimeType         = newVideData.videoDetails.mimeType;
      data.videoDetails.duration         = newVideData.videoDetails.duration;
      data.videoDetails.startTime        = 0;
      data.videoDetails.endTime          = newVideData.videoDetails.duration;
      data.videoDetails.audio            = newVideData.videoDetails.audio;
      data.videoDetails.videoHighRes     = newVideData.videoDetails.videoHighRes;
      EventBus.$emit('onObjectAdding', JSON.parse(JSON.stringify(data)));
    },
  },
};
